/**
 * Base proto links DTO
 */
export abstract class BaseProtoLinksDto {
  id!: number;
  accountId?: number | null;
  tenantOrgId?: string | null;
  agentId?: number | null;
  assetId?: number | null;
}
